(function () {
  if (window.__nestContactMapStability20260625) return;
  window.__nestContactMapStability20260625 = true;

  var previousInitMap = typeof window.initMap === 'function' ? window.initMap : null;
  var mapSelector = '.shops-container .map[data-lat][data-long], .shops-container .map[data-lat][data-lng]';

  function numberFromAttribute(element, names) {
    for (var i = 0; i < names.length; i += 1) {
      var value = element.getAttribute(names[i]);
      if (value !== null && value !== '') {
        var parsed = parseFloat(value);
        if (!isNaN(parsed)) return parsed;
      }
    }
    return null;
  }

  function mapCenterFor(element) {
    var lat = numberFromAttribute(element, ['data-lat']);
    var lng = numberFromAttribute(element, ['data-long', 'data-lng']);
    if (lat === null || lng === null) return null;
    return { lat: lat, lng: lng };
  }

  function isElementVisible(element) {
    return !!(element && element.offsetParent !== null && element.getClientRects().length);
  }

  function repairContactKeyboardOrder() {
    var mapSection = document.getElementById('shopify-section-shops-map') || document.querySelector('.showrooms');
    var stateSelect = document.getElementById('shops-state');
    var citySelect = document.getElementById('shops-city');

    if (stateSelect) {
      stateSelect.removeAttribute('tabindex');
      stateSelect.removeAttribute('aria-hidden');
      stateSelect.setAttribute('aria-label', 'Select location state');
    }

    if (citySelect) {
      citySelect.removeAttribute('tabindex');
      citySelect.removeAttribute('aria-hidden');
      citySelect.setAttribute('aria-label', 'Select location city');
    }

    if (!mapSection) return;

    var mapSvg = mapSection.querySelector('.showrooms__map > svg');
    if (mapSvg) {
      mapSvg.setAttribute('focusable', 'false');
    }

    Array.prototype.forEach.call(mapSection.querySelectorAll('ul.sr-only a[href]'), function (link) {
      link.setAttribute('tabindex', '-1');
      link.setAttribute('data-nest-contact-focus-skip', 'true');
    });
  }

  function ensureMap(element) {
    if (!window.google || !google.maps || !element) return;

    var center = mapCenterFor(element);
    if (!center) return;

    if (!element.__nestStoreMap) {
      element.__nestStoreMap = new google.maps.Map(element, {
        center: center,
        zoom: 12,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      });

      element.__nestStoreMarker = new google.maps.Marker({
        position: center,
        map: element.__nestStoreMap
      });
    }

    if (isElementVisible(element)) {
      google.maps.event.trigger(element.__nestStoreMap, 'resize');
      element.__nestStoreMap.setCenter(center);
      if (element.__nestStoreMarker) element.__nestStoreMarker.setPosition(center);
    }
  }

  function initializeStoreMaps() {
    if (!window.google || !google.maps) return;

    var maps = document.querySelectorAll(mapSelector);
    Array.prototype.forEach.call(maps, ensureMap);
  }

  function refreshVisibleMaps() {
    window.setTimeout(initializeStoreMaps, 0);
    window.setTimeout(initializeStoreMaps, 150);
    window.setTimeout(initializeStoreMaps, 500);
  }

  window.initMap = function nestContactMapInitMap() {
    if (previousInitMap && previousInitMap !== window.initMap) {
      try {
        previousInitMap.apply(window, arguments);
      } catch (error) {
        window.console && console.warn && console.warn('Previous map initializer failed; using contact map fallback.', error);
      }
    }

    repairContactKeyboardOrder();
    initializeStoreMaps();
    refreshVisibleMaps();
  };

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches('#shops-state, #shops-city')) {
      refreshVisibleMaps();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.shops-select, .options li, .styledSelect')) {
      refreshVisibleMaps();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      repairContactKeyboardOrder();
      refreshVisibleMaps();
    }, { once: true });
  } else {
    repairContactKeyboardOrder();
    refreshVisibleMaps();
  }
})();